import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const Share = ({ color = "lightblack" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19 16V18C19 19.1046 18.1046 20 17 20H5C3.89543 20 3 19.1046 3 18V6C3 4.89543 3.89543 4 5 4H13M21 9L17 5M21 9L17 13M21 9C12.5 9 9 10 9 15"
        stroke={COLORS[color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Share;
